import { Box, LoaderNew, ModBox, Spacer, Text, TextNew, TextNewProps } from '@jfs/ui-new'
import { FC, useEffect, useState } from 'react'
import { EmType } from '../..'
import { useLazyApiData, useStores } from '../../../../data/store'
import { SelectParentEntityList } from '../../Onboarding/CreateEntity/SelectParentEntityList'

const columnSize: any = {
  0: 1,
  1: 1,
}
const headerTitle = [{ title: 'DSN' }, { title: 'Status' }]
interface EmsDevicesProps {
  selectedEntity: any
  type: any
  isValidToProceed?: any
}
const EmsDevices: FC<EmsDevicesProps> = ({ selectedEntity, type, isValidToProceed }: EmsDevicesProps) => {
  const {
    getSearchDevices,
    getDevicesList,
    linkUnlink,
    searchedMasMid,
    searchedMasMidInMasFlow,
    fetchLov,
    getDevicesFromSearch,
  } = useStores((store) => ({
    getSearchDevices: store.fetchDevices,
    getDevicesList: store.onboarding.getDevicesList,
    linkUnlink: store.linkUnlinkMerchantWithDevice,
    searchedMasMid: store.onboarding.searchedMasMid,
    searchedMasMidInMasFlow: store?.onboarding?.entityDetails?.entity?.identificationNumber,
    fetchLov: store.fetchLov,
    getDevicesFromSearch: store.getDevicesFromSearch,
  }))

  const [devicesList, setDevicesList] = useState([])
  const [fetchSearchDevices, searchDevicesHandler] = useLazyApiData(getSearchDevices)
  // const [linkUnlinkRequest, linkUnlinkHandler] = useLazyApiData(linkUnlink)
  const [getSingleLov, getSingleLovHandler] = useLazyApiData(fetchLov)

  useEffect(() => {
    if (getSingleLovHandler.state === 'fulfilled') {
      if (selectedEntity && selectedEntity.id) {
        if (type === EmType.createSingleEntity) {
          fetchSearchDevices(selectedEntity.id)
        }
      } else if (searchedMasMid && selectedEntity?.applicationId?.length === 0) {
        fetchSearchDevices(searchedMasMid)
      } else if (selectedEntity && selectedEntity?.applicationId?.length > 0) {
        fetchSearchDevices(selectedEntity?.identificationNumber)
      } else if (
        searchedMasMidInMasFlow &&
        searchedMasMidInMasFlow?.length > 0 &&
        selectedEntity === undefined &&
        type === EmType.createSingleEntity
      ) {
        fetchSearchDevices(searchedMasMidInMasFlow)
      }
    }
  }, [fetchSearchDevices, getSingleLovHandler.state, searchedMasMid, searchedMasMidInMasFlow, selectedEntity, type])

  useEffect(() => {
    getSingleLov('DeviceStatus')
  }, [getSingleLov])

  useEffect(() => {
    if (searchDevicesHandler.state === 'fulfilled') {
      if (searchedMasMid.length > 0) {
        setDevicesList(getDevicesList(searchedMasMid, type))
        isValidToProceed && isValidToProceed(true)
      } else {
        setDevicesList(getDevicesList('', type))
        isValidToProceed && isValidToProceed(true)
      }
    } else if (searchDevicesHandler.state === 'rejected') {
      isValidToProceed && isValidToProceed(false)
    }
    if (type === EmType.Search) {
      setDevicesList(getDevicesFromSearch(selectedEntity?.id))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDevicesList, searchDevicesHandler.state])

  // useEffect(() => {
  //   if (linkUnlinkHandler.state === 'fulfilled') {
  //     setDevicesList(getDevicesList())
  //   } else if (linkUnlinkHandler.state === 'rejected') {
  //   }
  // }, [getDevicesList, linkUnlinkHandler.state])

  const onItemPress = (data: any) => {
    if (data) {
      // linkUnlinkRequest(data?.tid, data?.dsn, data?.unlink === 'Unlink' ? 'link' : 'unlink')
    }
  }
  return (
    <Box f={1} overflow={'auto'} ph={40} pv={40} nativeID="vertical-scroll" backgroundColor={'WHITE'}>
      <ModBox>
        <Box direction="row" w={'100%'} justifyContent={'space-between'}>
          <Box direction="row">
            <Text title={'Devices'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
          </Box>
        </Box>
        <ModBox
          h={'100%'}
          justifyContent={'center'}
          alignItems={'center'}
          show={searchDevicesHandler.state === 'pending' || getSingleLovHandler.state === 'pending'}>
          <LoaderNew color="PRIMARY" />
          <Spacer size={16} />
          <TextNew {...style.loadingText} color={'PRIMARY'} title={'Loading'} />
          <Spacer size={32} />
        </ModBox>
        <ModBox
          show={searchDevicesHandler.state !== 'pending' && getSingleLovHandler.state !== 'pending'}
          marginTop={16}>
          <SelectParentEntityList
            hide={false}
            title={''}
            data={devicesList}
            columnFlexMapper={columnSize}
            headerTitles={headerTitle}
            onItemPress={onItemPress}
          />
        </ModBox>
      </ModBox>
    </Box>
  )
}

export { EmsDevices }

const style = {
  loadingText: {
    type: 'bodyMedium14',
    textAlign: 'center',
    color: 'PRIMARY',
  } as TextNewProps,
}
